export const filterPaymentMethodsByCurrency = (paymentMethods, currency) => {
  if (!paymentMethods || !Array.isArray(paymentMethods)) {
    return [];
  }

  if (currency === 'USD') {
    return paymentMethods.filter(pm => pm.name === 'Divisas');
  } else if (currency === 'BS') {
    return paymentMethods.filter(pm => pm.name === 'Transferencia' || pm.name === 'Pagomovil' || pm.name === 'Bolivares');
  }
  return [];
};

const OBJECT_ID_RE = /^[a-fA-F0-9]{24}$/;

export const resolvePaymentMethodName = (payment, paymentMethods = []) => {
  const raw = payment?.paymentMethod;
  if (!raw) return "No especificado";
  if (typeof raw === "object" && raw.name) return raw.name;

  if (typeof raw === "string") {
    const match = (paymentMethods || []).find(
      (pm) => String(pm._id) === raw || pm.name === raw,
    );
    if (match) return match.name;
    if (OBJECT_ID_RE.test(raw)) return "No especificado";
    return raw;
  }

  return "No especificado";
};

export const invoiceHasPendingBalance = (invoice) =>
  Number(invoice?.pendingAmount) > 0.01;
